var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M250,22C157.54,22,85.35,91.68,85.35,180.34c0,19.63,7.6,58.89,20.26,87.39C146.77,362.09,236.7,469.12,240.5,473.55A11.41,11.41,0,0,0,250,478c3.8,0,7-1.9,9.5-4.43,3.8-4.43,93.72-111.46,134.89-205.82,12.66-28.5,20.26-67.76,20.26-87.39C414.65,91.68,342.46,22,250,22Zm0,253.31a88.66,88.66,0,1,1,88.66-88.66A88.92,88.92,0,0,1,250,275.33Z","transform":"translate(-85.35 -22.02)","style":{"fill":"#b58b51"}}));
}

Pin.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 329.31 455.96"};

module.exports = Pin;

Pin.default = Pin;
